module.exports = __webpack_public_path__ + "img/angular.7d096353.svg";